<template>
  <!--
    readExcelData: function(rowNumber, cells, dataTypes, func) excel data 읽을 때 사용
      - rowNumber: 현재 row number
      - cells: 현재 row 의 cell data
      - dataTypes: tableDataType, 사용자가 임의로 정하는 타입
      - func: ExcelUploadNormalTemplate.vue 의 method
        - func.save(cells, error) excel data 저장
        - func.findFieldByFieldName(fieldName) fieldName 으로 field 찾기, useFieldCell 이 true 일때만 사용
        - func.toTel(string) string 을 전화번호 타입으로 변경

    setSaveFormData
  -->
  <normal-excel-upload
    :board="board"
    title="수급업체 안전보건예산 엑셀 업로드"
    :useFieldCell="true"
    :useCompanyCell="true"
    :downloadLink="downloadLink"
    tableTitle="수급업체 안전보건예산 정보"
    :tableHeader="tableHeader"
    :tableDataType="tableDataType"
    :readExcelData="readExcelData"
    :setSaveFormData="setSaveFormData"
  >
    <!--
      index: column index
      data: column data
      dataType: 사용자가 임의로 정하는 타입
      funcSetEditExcelData: function(index, data, errorMSG) edit excel data 수정시 사용
        - errorMGS = "": 정상
        - errorMGS = "error message": 에러 메시지
        - errorMGS = undefined: 에러 메시지 변경안함
    -->
    <template v-slot:edit="{ index, rowData, data, dataType, funcSetEditExcelData }">
      <fragment v-if="dataType === 'no'">{{ data }}</fragment>
      <fragment v-else-if="index === 6 || index === 7">
        {{ data | comma }}
      </fragment>
      <fragment v-else-if="dataType === 'field'">
        <field-selector class="w-full text-left" v-model="data.id" @select="(field) => onSelectField(field, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else-if="dataType === 'company'">
        <CompanySelector class="w-full text-left" v-model="data.id" @select="(company) => onSelectCompany(company, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else-if="['year', 'month'].indexOf(dataType) >= 0">
        <ml-input class="w-full" type="number" :value="data" :max-value="dataType === 'month' ? 12 : 9999" :min-value="dataType === 'month' ? 1 : 0" @input="(date) => onChangeDate(date, dataType, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else-if="dataType === 'number'">
        <number-input class="w-full" :value="data" @input="(number) => onChangeNumber(number, rowData, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else>
        <ml-input class="w-full" :value="data" @input="(value) => funcSetEditExcelData(index, value, '')" />
      </fragment>
    </template>
    <template v-slot:column="{ index, data, dataType }">
      <p v-if="index === 1">{{ data.field_name || "-" }}</p>
      <p v-else-if="index === 2">{{ data.com_name || "-" }}</p>
      <p v-else-if="dataType === 'number'">{{ data || "" | comma }}</p>
      <p v-else>{{ data || "-" }}</p>
    </template>
  </normal-excel-upload>
</template>

<script>
import NormalExcelUpload from "@/views/excel-upload/NormalExcelUpload.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector";
import DateSelector from "@/components/selector/DateSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import config from "/public/config";

export default {
  components: {
    NumberInput,
    DateSelector,
    FieldSelector,
    CompanySelector,
    NormalExcelUpload,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%EC%88%98%EA%B8%89%EC%97%85%EC%B2%B4_%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EC%98%88%EC%82%B0_%EC%97%91%EC%85%80%EB%93%B1%EB%A1%9D_ver2.xlsx`,
      tableDataType: ["no", "field", "company", "year", "number", "number", "number", "number"],
      tableHeader: ["No.", "사업장명", "업체명", "대상년도", "예산", "집행실적", "지출잔액", "집행률(%)"],
      tableDataValue: ["예산", "집행실적", "지출잔액", "집행률"],

      field: undefined,
      company: undefined,

      header: {
        year: 0,
        month: 0,
        date: "",
        full: "",
      },
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  methods: {
    onSelectField(field, edit) {
      const data = {
        id: field.id,
        field_name: field.field_name,
      };
      const errorMSG = field.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      edit.funcSetEditExcelData(edit.index, data, errorMSG);
    },
    onSelectCompany(company, edit) {
      console.log("onSelectCompany");
      const data = {
        id: company.id,
        com_name: company.com_name,
      };
      const errorMSG = company.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      edit.funcSetEditExcelData(edit.index, data, errorMSG);
    },
    onChangeDate(date, dateType, edit) {
      const iDate = Number(date);
      let errorMSG = !isNaN(iDate) ? "" : "숫자만 입력 가능합니다.";

      if (!errorMSG) {
        if (dateType === "year") {
          errorMSG = `${date}`.length === 4 ? "" : "4자리 숫자만 입력 가능합니다.";
        } else if (dateType === "month") {
          errorMSG = iDate >= 1 && iDate <= 12 ? "" : "1 ~ 12 사이의 숫자만 입력 가능합니다.";
        }
      }
      edit.funcSetEditExcelData(edit.index, date, errorMSG);
    },
    onChangeNumber(number, rowData, edit) {
      rowData[edit.index] = number;
      const 예산 = rowData[4];
      const 집행실적 = rowData[5];
      const 지출잔액 = 예산 - 집행실적;
      const 집행률 = (예산 > 0 ? (집행실적 / 예산) * 100 : 0).toFixed(2);
      edit.funcSetEditExcelData(6, 지출잔액, "");
      edit.funcSetEditExcelData(7, 집행률, "");
    },
    readExcelData(rowNumber, cells, dataTypes, func) {
      if (rowNumber === 1) {
        this.field = func.findFieldByFieldName(cells[4]) || {
          id: 0,
          field_name: cells[4],
        };
      }

      if (rowNumber === 2) {
        this.company = func.findCompanyByComName(cells[4]) || {
          id: 0,
          com_name: cells[4],
        };
      }
      if (rowNumber === 3) {
        const 대상년도 = cells[4];
        this.header.year = 대상년도;
      }

      if (rowNumber === 8) {
        const error = [];

        if (this.field.id === 0) {
          error[1] = "입력된 데이터가 검색되지 않습니다.";
        }

        if (this.company.id === 0) {
          error[2] = "입력된 데이터가 검색되지 않습니다.";
        }

        if (isNaN(Number(this.header.year))) {
          error[3] = "숫자만 입력 가능합니다.";
        }

        const data = [];
        data[0] = func.rowIndex;
        data[1] = this.field;
        data[2] = this.company;
        data[3] = this.header.year;
        data[4] = cells[1];
        data[5] = cells[2];
        data[6] = cells[3];
        data[7] = cells[4];
        func.save(data, error);
      }
    },

    setSaveFormData(datas, stdInfo) {
      const form = {
        stdInfo: {
          ...stdInfo,
          field_id: datas[1].id,
          field_name: datas[1].field_name,
        },
        관리비: {
          예산: 0,
          집행실적: 0,
          지출잔액: 0,
          집행률: 0.0,
        },

        업체명: datas[2].com_name,
        업체: datas[2].id,
      };
      this.tableDataValue.forEach((key, index) => {
        form.관리비[key] = Number(datas[index + 4]);
      });

      const header = {
        year: datas[3],
        month: "01",
        date: new Date().format("yyyy-MM-dd"),
        full: new Date(`${datas[3]}-01-01`).format("yyyy-MM-dd"),
      };

      return {
        header,
        body: form,
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
